import * as fromDatatype from '../datatype-library/index';
import {bl_fi_mst_shipping_price_book_event_RowInterface} from "./bl_fi_mst_shipping_price_book_event.model";

export interface bl_fi_mst_shipping_price_book_rule_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  price_book_hdr_guid: fromDatatype.GuidDataFieldInterface;
  price_book_line_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  rule_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  rule_json: fromDatatype.JsonDatatypeInterface;
  contact_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_shipping_price_book_rule_hdr_RowClass
  implements bl_fi_mst_shipping_price_book_rule_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  price_book_hdr_guid: fromDatatype.GuidDataFieldInterface;
  price_book_line_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  rule_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  rule_json: fromDatatype.JsonDatatypeInterface;
  contact_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
